import React, { SVGProps } from 'react';

export const GrapLineIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3333 9.81667L16.8666 3.70833L18.3083 4.54167L13.95 12.0833L8.52496 8.95833L4.54996 15.8333H18.3333V17.5H1.66663V2.5H3.33329V14.6167L7.91663 6.66667L13.3333 9.81667Z"
        fill="currentColor"
      />
    </svg>
  );
};
